import React from 'react'
import Header from './Header'
import Footer from './Footer'

class Template extends React.Component {
  render() {
    return (
      <div>
        <Header />
        <main className="ng-page">{this.props.children}</main>
        <Footer />
      </div>
    )
  }
}

export default Template
